import API from "./index";

// create buyerForm
const createBuyerForm = async (params = {}) => {
  try {
    delete params.amenities;
    const { data } = await API.post("/create_buyer_forms", {
      ...params,
    });
    return data;
  } catch (error) {
    // Handle error
    console.error("Error fetching property data:", error);
    return null;
  }
};

const createSellerForm = async (params = {}) => {
  try {
    const { data } = await API.post("/create_seller_forms", {
      ...params,
    });
    return data;
  } catch (error) {
    // Handle error
    console.error("Error fetching property data:", error);
    return null;
  }
};

export { createBuyerForm, createSellerForm };
